/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:57:16
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/columnNotice.js
 */
export default {
    // columnNotice 组件
    columnNotice: {
        text: '',
        icon: 'volume',
        mode: '',
        color: '#f9ae3d',
        bgColor: '#fdf6ec',
        fontSize: 14,
        speed: 80,
        step: false,
        duration: 1500,
        disableTouch: true
    }
}
